import { z } from 'zod';
/**
 * @description `POST /api/payment/checkout` 请求的校验 schema
 *              用于验证 request body。
 */
export const initiateCheckoutRequestSchema = z.object({
    planType: z.enum(['free', 'plus', 'pro'], {
        required_error: 'planType is required.',
        invalid_type_error: "planType must be one of 'free', 'plus', or 'pro'.",
    }),
    referralCode: z.string().optional(),
    mode: z.enum(['payment', 'subscription']).optional(),
});
//# sourceMappingURL=checkout.schemas.js.map